import "babel-polyfill";

import Vue from "vue";
import "element-ui/lib/theme-default/index.css";
import ElementUI from "element-ui";
import "vue-awesome/icons";
import Icon from "vue-awesome/components/Icon";
import Vuex from "vuex";
import store from "@/store";
import Raven from "raven-js";
import RavenVue from "raven-js/plugins/vue";
import locale from "element-ui/lib/locale/lang/en";
import FlagIcon from "vue-flag-icon";
import VTooltip from "v-tooltip";
import { VPopover } from "v-tooltip";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCheck, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { faCircle } from "@fortawesome/free-regular-svg-icons";
import {
  FontAwesomeIcon,
  FontAwesomeLayers
} from "@fortawesome/vue-fontawesome";

import CheckPermission from "@/shared/components/CheckPermission";

import App from "./App";
import router from "./router";

library.add(faCheck, faCircle, faInfoCircle);

Vue.config.productionTip = false;

if (process.env.NODE_ENV === "production") {
  Raven.config("https://c6f7ca6b519b45e88eb64d696f8eaacc@sentry.io/197863", {
    autoBreadcrumbs: false
  })
    .addPlugin(RavenVue, Vue)
    .install();
}

Vue.use(FlagIcon);
Vue.use(ElementUI, { locale });
Vue.use(Vuex);
Vue.use(ElementUI);
Vue.use(VTooltip);

Vue.component("fa-icon", FontAwesomeIcon);
Vue.component("fa-layers", FontAwesomeLayers);
Vue.component("icon", Icon);
Vue.component("check-permission", CheckPermission);
Vue.component("v-popover", VPopover);

Vue.config.productionTip = false;
// router.afterEach(() => {
//   window.Intercom('update')
// })

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: { App }
});
